export default __webpack_public_path__ + "static/media/codematata.5acde3cb.svg";